const PRODUCT_NAME  = process.env.REACT_APP_PRODUCT_NAME  ?? "Tu Producto";
const COMPANY_NAME  = process.env.REACT_APP_COMPANY_NAME  ?? "Tu Empresa";
const COMPANY_ADDR  = process.env.REACT_APP_COMPANY_REGISTERED_ADDRESS ?? "Tu Dirección Registrada";
const COMPANY_NO    = process.env.REACT_APP_COMPANY_REGISTERED_NUMBER ?? "00000000";
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL ?? "soporte@ejemplo.com";

export const TERMS_HTML_ES = `

<p><strong>Proveedor:</strong> ${COMPANY_NAME} (N.º de empresa ${COMPANY_NO}), registrada en Inglaterra y Gales, con domicilio social en ${COMPANY_ADDR} (“<em>Nosotros</em>”).</p>
<p><strong>Cliente:</strong> La empresa que utiliza los Servicios, es decir, la entidad que crea una cuenta o que figura en cualquier formulario de pedido o suscripción (“<em>Tú/Cliente</em>”).</p>

<h4>1. El Servicio</h4>
<ul>
<li>Ofrecemos una plataforma de reservas SaaS denominada <strong>${PRODUCT_NAME}</strong> (“<em>Servicios</em>”), que incluye: configuración de personal y servicios, horarios del personal, calendario con eventos únicos o recurrentes, registros de clientes y citas con notas, búsqueda, panel de control, portal de reservas y mini-sitio opcional, comunicaciones transaccionales y, opcionalmente, integración de pagos con Stripe Connect.</li>
</ul>

<h4>2. Cuentas y Elegibilidad</h4>
<ul>
  <li>Debes proporcionar información precisa y mantener seguras tus credenciales.</li>
  <li>Eres responsable de las acciones realizadas bajo tu cuenta por tus usuarios.</li>
  <li>Debes estar autorizado para vincular a tu empresa con estos Términos.</li>
</ul>

<h4>3. Tarifas y Pagos</h4>
<ul>
  <li>Las suscripciones se facturan según lo indicado en el momento del pedido o en la facturación dentro de la aplicación. Las tarifas se pagan por adelantado y no son reembolsables salvo que lo exija la ley.</li>
  <li>Los planes se renuevan automáticamente, salvo que canceles antes de la fecha de renovación.</li>
  <li>Podemos suspender o terminar los Servicios por falta de pago tras la notificación correspondiente.</li>
  <li>Los precios no incluyen los impuestos aplicables, que son tu responsabilidad.</li>
</ul>

<h4>4. Uso Aceptable</h4>
<ul>
  <li>No utilices los Servicios de manera ilegal ni para infringir los derechos de terceros.</li>
  <li>No subas código malicioso, intentes eludir la seguridad ni sobrecargues el Servicio.</li>
  <li>No envíes spam ni comunicaciones comerciales sin base legal ni consentimiento válido cuando sea necesario.</li>
  <li>No recopiles ni almacenes datos de categorías especiales (por ejemplo, de salud) salvo que sea estrictamente necesario y legal. Si necesitas realizar dicho tratamiento, contáctanos primero.</li>
</ul>

<h4>5. Contenido del Cliente y Responsabilidad</h4>
<ul>
  <li>Conservas todos los derechos sobre tu contenido (detalles de negocio, fotos del personal, servicios, listas de clientes, notas).</li>
  <li>Nos concedes una licencia no exclusiva para alojar, procesar y transmitir tu contenido únicamente para proporcionar y mejorar los Servicios.</li>
  <li>Eres responsable de la exactitud y legalidad de tu contenido y de las comunicaciones con tus clientes.</li>
</ul>

<h4>6. Nuestra Propiedad Intelectual</h4>
<ul>
<li>Nosotros (y nuestros licenciantes) conservamos todos los derechos sobre los Servicios, el software, la documentación y la marca. No se otorgan derechos salvo los expresamente indicados en estos Términos.</li>
</ul>

<h4>7. Privacidad y Protección de Datos</h4>
<ul>
<li>La protección de datos se rige por nuestro <strong>Anexo de Tratamiento de Datos (DPA)</strong>, que forma parte de estos Términos. Tú eres el Responsable del tratamiento de los datos de tus clientes; nosotros actuamos como Encargado. Debes publicar avisos de privacidad adecuados en tu portal o mini-sitio de reservas y obtener los consentimientos necesarios (por ejemplo, para comunicaciones comerciales).</li>
</ul>

<h4>8. Cookies y Autenticación</h4>
<ul>
<li>La aplicación utiliza una cookie de autenticación <em>estrictamente necesaria</em> llamada <code>Access-Token</code> (un JWT) con una duración aproximada de 24 horas para proteger las cuentas y sesiones. El portal de reservas no utiliza cookies analíticas por defecto. El almacenamiento local puede guardar preferencias no esenciales de la interfaz (por ejemplo, paginación) en el dispositivo.</li>
</ul>

<h4>9. Pagos a través de Stripe</h4>
<ul>
<li>Los pagos en línea se procesan mediante <strong>Stripe Connect</strong>. Los datos de la tarjeta se introducen directamente en Stripe; no almacenamos los números de tarjeta. Tu uso de Stripe está sujeto a los términos y política de privacidad de Stripe.</li>
</ul>

<h4>10. Cambios y Disponibilidad del Servicio</h4>
<ul>
  <li>Podemos mejorar o modificar las funcionalidades de vez en cuando. Si retiramos una funcionalidad importante, te daremos un aviso razonable.</li>
  <li>Nos esforzamos por ofrecer disponibilidad fiable, pero no garantizamos un Servicio ininterrumpido.</li>
</ul>

<h4>11. Soporte</h4>
<ul>
<li>El soporte está disponible mediante tickets en la aplicación o por correo electrónico a <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>.</li>
</ul>

<h4>12. Suspensión</h4>
<ul>
<li>Podemos suspender los Servicios por falta de pago, riesgos de seguridad, cumplimiento legal o incumplimiento grave, con aviso previo cuando sea razonable.</li>
</ul>

<h4>13. Duración y Terminación</h4>
<ul>
  <li>Estos Términos permanecen vigentes hasta su terminación. Cualquiera de las partes puede resolver el contrato por conveniencia con 30 días de preaviso, o por incumplimiento grave si no se corrige dentro de los 30 días posteriores al aviso.</li>
  <li>Al finalizar, podrás exportar tus datos. Eliminaremos los datos personales de acuerdo con el DPA (incluidos los plazos de retención y copias de seguridad).</li>
</ul>

<h4>14. Garantías y Exenciones</h4>
<ul>
<li>Prestaremos los Servicios con la diligencia y competencia razonables. Salvo lo aquí indicado, los Servicios se ofrecen “tal cual”, y renunciamos a las garantías implícitas de comerciabilidad, idoneidad para un propósito particular y no infracción, en la máxima medida permitida por la ley.</li>
</ul>

<h4>15. Limitación de Responsabilidad</h4>
<ul>
<li>En la máxima medida permitida por la ley, ninguna de las partes será responsable por daños indirectos, incidentales, especiales o consecuentes, pérdidas de beneficios o ingresos, o pérdida de datos, incluso si se advirtió de su posibilidad. La responsabilidad total de cada parte derivada de los Servicios en cualquier período de 12 meses se limita a las tarifas pagadas o pagaderas por ti a nosotros en ese período. Nada excluye la responsabilidad por muerte o lesiones personales causadas por negligencia, fraude o cuestiones que no puedan excluirse por ley.</li>
</ul>

<h4>16. Indemnizaciones</h4>
<ul>
  <li><strong>Tu indemnización:</strong> Nos indemnizarás frente a reclamaciones de terceros derivadas de tu uso ilegal de los Servicios, tu contenido o tu falta de avisos/consentimientos legales.</li>
  <li><strong>Nuestra indemnización:</strong> Te indemnizaremos frente a reclamaciones de terceros que aleguen que los Servicios (según los proporcionamos) infringen derechos de propiedad intelectual, sujeto a exclusiones habituales y a tu aviso y cooperación inmediatos.</li>
</ul>

<h4>17. Confidencialidad</h4>
<ul>
<li>Cada parte protegerá la información confidencial de la otra y la usará únicamente para los fines previstos en estos Términos.</li>
</ul>

<h4>18. Legislación Aplicable y Jurisdicción</h4>
<ul>
<li>Estos Términos se rigen por las leyes de Inglaterra y Gales. Los tribunales de Inglaterra y Gales tendrán jurisdicción exclusiva, salvo que cualquiera de las partes pueda solicitar medidas cautelares en cualquier tribunal competente.</li>
</ul>

<h4>19. Cambios en estos Términos</h4>
<ul>
<li>Podemos actualizar estos Términos para reflejar cambios en la ley o en los Servicios. Notificaremos con antelación razonable los cambios importantes al correo electrónico de tus administradores de cuenta o dentro de la aplicación. El uso continuado después de la fecha efectiva constituye aceptación.</li>
</ul>

<h4>20. Fuerza Mayor</h4>
<ul>
<li>Ninguna de las partes será responsable de retrasos o fallos debidos a eventos fuera de su control razonable (por ejemplo, cortes de internet, fallos eléctricos o desastres naturales).</li>
</ul>

<h4>21. Notificaciones</h4>
<ul>
<li>Notificaciones a ${COMPANY_NAME}: <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a> y la dirección registrada indicada arriba. Notificaciones para ti: al correo electrónico asociado a tu cuenta.</li>
</ul>

<h4>22. Orden de Precedencia</h4>
<ul>
<li>Si existe conflicto entre estos Términos y el DPA, prevalecerá el DPA en lo relativo a protección de datos.</li>
</ul>
`;
